import React, {Component} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

class SpinnerButton extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {
        let {
            title = 'Gem',
            type = 'submit',
            className = 'btn btn-primary waves-effect waves-light clickable',
            onClick,
        } = this.props;

        if(this.props.showSpinner) {
            return <button disabled type={type} className={`${className} disabled`}><i className="fa fa-spin fa-spinner"></i> {'Arbejder...'}</button>;
        }

        return <button onClick={onClick} className={className} type={type}>{title}</button>;
    }
};

function mapStateToProps(state, ownProps) {
    return {
        showSpinner: state.buttonsWithSpinner.indexOf(ownProps.id) !== -1,
    };
}

export default connect(mapStateToProps)(SpinnerButton);


// WEBPACK FOOTER //
// ./web/src/components/common/SpinnerButton.jsx